<template>
    <div class="about-page">
        <TopBar/>
        <template v-for="(item,index) in config">
            <img :src="item.image" :key="index">
        </template>
        <FootBar/>
    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import FootBar from '@components/footBar'
import TopBar from '@components/topBar'

export default {
    data() {
        return {
            config: []
        }
    },
    async created() {
        this.$store.dispatch('getUserInfo')
        const { type = 'appPage' } = this.$route.query
        const res = await this.$store.dispatch('about/getCMSConfig')
        const config = res.data || {}
        this.config = config[type]
    },
    components: {
        TopBar,
        FootBar
    }
}
</script>
<style lang="scss" scoped>
.about-page{
    img{
        width: 100%;
    }
}
</style>
